export enum DOCUMENT_UPLOADER_TYPE {
  OTHER = 'Other',
  SYSTEM = 'System',
  OWNER = 'Owner',
}

export interface Document {
  extension: string;
  id?: string;
  name?: string;
  originalFileName?: string;
  url: string;
  uploaderType?: DOCUMENT_UPLOADER_TYPE;
  customerVisibility?: boolean;
}

export enum DocumentType {
  DELIVERY_RECEIPT = 'DeliveryReceipt',
  EXCHANGE_VOUCHER = 'ExchangeVoucher',
  INTERVENTION_REPORT = 'InterventionReport',
  IMPORT_REJECT_REPORT = 'ImportRejectsReport',
  QUOTE = 'Quote',
  RETURN_VOUCHER = 'ReturnVoucher',
  CASHING_RECEIPT = 'CashingReceipt',
  DATA_LOSS_LIABILITY_WAIVER = 'DataLossLiabilityWaiver',
  DEPOSIT_VOUCHER = 'DepositVoucher',
  DESTRUCTION_VOUCHER = 'DestructionVoucher',
  FILE_SUMMARY_REPORT = 'FileSummaryReport',
  HAND_BACK_VOUCHER = 'HandBackVoucher',
  HANDLING_VOUCHER = 'HandlingVoucher',
  PROOF_OF_PURCHASE = 'ProofOfPurchase',
  REFUND_VOUCHER = 'RefundVoucher',
  SHIPPING_SUMMARY = 'ShippingSummary',
  SHIPPING_VOUCHER = 'ShippingVoucher',
  UNEXPECTED_RETURN_VOUCHER = 'UnexpectedReturnVoucher',
  PRODUCT_SUMMARY = 'ProductSummary',
  EUROPEAN_WARRANTY_FORM = 'EuropeanWarrantyForm',
  PICTURE = 'Picture',
  CREDIT_NOTE = 'CreditNote',
  NAME_PLATE = 'NamePlate',
  RCA = 'RCA',
  PRODUCTS_TO_COLLECT = 'ProductsToCollect',
}
